const STRIPBOARD_FLOATING_POPUP_ATTR = "data-stripboard-floating-popup";
const STRIPBOARD_FLOATING_POPUP_REFERENCE_ATTR = "data-stripboard-floating-popup-reference";
const GOOGLE_MAPS_PLACES_SUGGESTIONS_ATTR = "data-google-maps-place-suggestions";

const DATE_PICKER_SELECTOR = '[class*="react-datepicker"]';

const RADIX_PORTAL_SELECTOR = [
  "[data-radix-popper-content-wrapper]",
  "[data-radix-select-content]",
  "[data-radix-menu-content]",
].join(",");

type DismissEvent = {
  preventDefault: () => void;
  target: EventTarget | null;
  composedPath?: () => EventTarget[];
  detail?: {
    originalEvent?: Event;
  };
};

const getPointerEventNodes = (event: {
  target: EventTarget | null;
  composedPath?: () => EventTarget[];
}): EventTarget[] => {
  if (typeof event.composedPath === "function") {
    const path = event.composedPath();
    if (path.length > 0) {
      return path;
    }
  }

  return event.target !== null ? [event.target] : [];
};

const getDismissInteractionNodes = (event: DismissEvent): EventTarget[] => {
  const originalEvent = event.detail?.originalEvent;
  if (originalEvent) {
    const originalNodes = getPointerEventNodes(originalEvent);
    if (originalNodes.length > 0) {
      return originalNodes;
    }
  }

  return getPointerEventNodes(event);
};

export const isPortaledOverlayDismissTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) {
    return false;
  }

  if (target.closest(DATE_PICKER_SELECTOR)) {
    return true;
  }

  if (target.closest(`[${STRIPBOARD_FLOATING_POPUP_ATTR}]`)) {
    return true;
  }

  if (target.closest(`[${STRIPBOARD_FLOATING_POPUP_REFERENCE_ATTR}]`)) {
    return true;
  }

  if (target.closest(`[${GOOGLE_MAPS_PLACES_SUGGESTIONS_ATTR}]`)) {
    return true;
  }

  if (target.closest(RADIX_PORTAL_SELECTOR)) {
    return true;
  }

  return false;
};

export const isPortaledOverlayInteraction = (event: DismissEvent): boolean => {
  return getDismissInteractionNodes(event).some((node) => isPortaledOverlayDismissTarget(node));
};

export const preventDialogDismissOnPortaledOverlay = (event: DismissEvent): void => {
  if (isPortaledOverlayInteraction(event)) {
    event.preventDefault();
  }
};
